module.exports = __webpack_public_path__ + "on_ramp_left.svg?abb0c355c7aab0203cc0b4fce93cb79f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/on_ramp_left.svg
// module id = 200
// module chunks = 0